import React, { Component } from 'react';
import {
  Button,
  FormGroup, Label,
  Input,
  Row, Col, InputGroup, InputGroupAddon,
  Card, CardBody
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Validation from '../../services/Validation';
import Select from 'react-select'
import TextareaAutosize from 'react-textarea-autosize';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
class NewFleetPersonalDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      controls: {
        is_prospective: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        home_address: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        birth_date: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        anniversary_date: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        education_qualification: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        languages: {
          value: [],
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        marital_status: {
          value: 'unmarried',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        child_1_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        child_2_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        child_1_dob: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        child_2_dob: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        spouse_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        spouse_dob: {
          value: null,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        isAddChild: {
          value: false,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
      },
      isValidForm: false,
      fleetByIdData: {}
    }
  }

  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { home_address, birth_date, anniversary_date, education_qualification, languages } = controls;

    if (home_address.touched === true || isSubmit) {
      home_address = Validation.notNullValidator(home_address);
      home_address.valid = !(home_address.nullValue);
      if (home_address.valid === false) {
        home_address.showErrorMsg = true;
      } else {
        home_address.showErrorMsg = false;
      }
    }

    if (birth_date.touched === true || isSubmit) {
      birth_date = Validation.notNullValidator(birth_date);
      birth_date.valid = !(birth_date.nullValue);
      if (birth_date.valid === false) {
        birth_date.showErrorMsg = true;
      } else {
        birth_date.showErrorMsg = false;
      }
    }
    if (education_qualification.touched === true || isSubmit) {
      education_qualification = Validation.notNullValidator(education_qualification);
      education_qualification.valid = !(education_qualification.nullValue);
      if (education_qualification.valid === false) {
        education_qualification.showErrorMsg = true;
      } else {
        education_qualification.showErrorMsg = false;
      }
    }
    if (languages.touched === true || isSubmit) {
      if (languages.value && languages.value.length > 0) {
        languages.showErrorMsg = false;
        languages.valid = true;
      } else {
        languages.showErrorMsg = true;
      }
    }


    if (anniversary_date.touched === true || isSubmit && controls.marital_status.value === 'married') {
      anniversary_date = Validation.notNullValidator(anniversary_date);
      anniversary_date.valid = !(anniversary_date.nullValue);
      if (anniversary_date.valid === false) {
        anniversary_date.showErrorMsg = true;
      } else {
        anniversary_date.showErrorMsg = false;
      }
    } else {
      anniversary_date.showErrorMsg = false;
      anniversary_date.valid = true;
    }

    if (controls.is_prospective.value) {
      home_address.valid = true;
      home_address.showErrorMsg = false;
      birth_date.valid = true;
      birth_date.showErrorMsg = false;
      education_qualification.valid = true;
      education_qualification.showErrorMsg = false;
      languages.valid = true;
      languages.showErrorMsg = false;
    }

    if (home_address.valid === true &&
      birth_date.valid === true && education_qualification.valid &&
      languages.valid === true) {
      if (controls.marital_status.value === 'married') {
        if (anniversary_date.valid === true) {
          isValidForm = true;
        } else {
          isValidForm = false;
        }
      } else {
        isValidForm = true;
      }
    } else {
      isValidForm = false;
    }


    this.setState({ controls, isValidForm });
    return isValidForm;

  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    if (controlName === 'isAddChild') {
      if (controls.marital_status.value === 'unmarried') {
        controls.isAddChild.value = false;
      }
    } else if (controlName === 'marital_status') {
      if (controlValue === 'unmarried') {
        controls.isAddChild.value = false;
        controls.spouse_dob.value = null;
        controls.anniversary_date.value = null;
        controls.spouse_name.value = '';
        controls.child_1_name.value = '';
        controls.child_1_dob.value = null;
        controls.child_2_name.value = '';
        controls.child_2_dob.value = null;
      }
    }
    controls[controlName].touched = true;
    this.setState({ controls });
    // if (controlName === 'home_address') {
    this.handleValidation();
    //}
  }

  setFleetDetail = (uDetail = {}) => {
    let { fleetByIdData, controls } = this.state;
    if (this.props.fleetByIdData && Object.keys(this.props.fleetByIdData).length > 0) {
      fleetByIdData = this.props.fleetByIdData;
    }
    if (uDetail && Object.keys(uDetail).length > 0) {
      fleetByIdData = uDetail;
    }
    if (fleetByIdData && Object.keys(fleetByIdData).length > 0) {
      controls.home_address.value = fleetByIdData.home_address;
      controls.birth_date.value = fleetByIdData.birth_date ? new Date(fleetByIdData.birth_date) : null;
      controls.spouse_dob.value = fleetByIdData.spouse_dob ? new Date(fleetByIdData.spouse_dob) : null;
      controls.spouse_name.value = fleetByIdData.spouse_name ? fleetByIdData.spouse_name : '';
      controls.anniversary_date.value = fleetByIdData.anniversary_date ? new Date(fleetByIdData.anniversary_date) : null;
      if (fleetByIdData.languages && fleetByIdData.languages.length > 0) {
        controls.languages.value = [];
        fleetByIdData.languages.forEach(element => {
          if (element) {
            controls.languages.value.push({
              value: element && element[0].toUpperCase() + element.slice(1),
              label: element && element[0].toUpperCase() + element.slice(1)
            })
          }
        });
      }
      if (fleetByIdData.child_1_dob || fleetByIdData.child_1_name ||
        fleetByIdData.child_2_dob || fleetByIdData.child_2_name) {
        controls.isAddChild.value = true;
      }

      controls.child_1_dob.value = fleetByIdData.child_1_dob ? new Date(fleetByIdData.child_1_dob) : null;
      controls.child_1_name.value = fleetByIdData.child_1_name ? fleetByIdData.child_1_name : '';
      controls.child_2_dob.value = fleetByIdData.child_2_dob ? new Date(fleetByIdData.child_2_dob) : null;
      controls.child_2_name.value = fleetByIdData.child_2_name ? fleetByIdData.child_2_name : '';
      controls.education_qualification.value = fleetByIdData.education_qualification;

      if (fleetByIdData.marital_status === 'married') {
        controls.marital_status.value = 'married';
      } else if (fleetByIdData.marital_status === 'unmarried') {
        controls.marital_status.value = 'unmarried';
      } else {
        controls.marital_status.value = fleetByIdData.marital_status ? 'married' : 'unmarried';
      }

      this.setState({
        controls,
        fleetByIdData
      }, () => {
        if (this.props.refresh_state) {
          this.props.refresh_state();
        }
      })
    }
  }

  changeFleetRegType = (e) => {
    const { NewFleetBusinessDetail } = this.props;
    let { controls } = this.state;

    if (NewFleetBusinessDetail.current &&
      NewFleetBusinessDetail.current.state.controls) {
      const { is_prospective } = NewFleetBusinessDetail.current.state.controls;
      if (is_prospective.value) {
        controls.is_prospective.value = is_prospective.value;
      } else {
        controls.is_prospective.value = "";
      }
    }
    this.setState({
      controls
    });
  }
  save = () => {
    if (!this.handleValidation(true)) {
      return
    }
    this.props.onSave();
  }

  handleOnCancel = () => {
    this.setFleetDetail({});
    this.props.onCancel('isPersonalDetailEditActive', false);
  }
  setLoading = (isLoading) => {
    this.setState({
      isLoading: isLoading
    })
  }
  render() {
    const { controls } = this.state;
    const options = [
      { value: 'English', label: 'English' },
      { value: 'Gujarati', label: 'Gujarati' },
      { value: 'Hindi', label: 'Hindi' },
      { value: 'Kannada', label: 'Kannada' },
      { value: 'Malayalam', label: 'Malayalam' },
      { value: 'Marathi', label: 'Marathi' },
      { value: 'Punjabi', label: 'Punjabi' },
      { value: 'Sindhi', label: 'Sindhi' },
      { value: 'Telugu', label: 'Telugu' },
      { value: 'Tamil', label: 'Tamil' },
    ]
    return (
      <>
        {this.state.isLoading && <CustomSpinner />}
        <Card>
          <CardBody>
            <Row>
              <Col>
                <b className="margin-right-16">PERSONAL DETAILS</b>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xl="4" md="12" xs="12">
                <FormGroup>
                  <Label for="home_address">Home Address{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <TextareaAutosize
                    name="home_address"
                    autocomplete="nofill"
                    id="home_address"
                    value={controls.home_address.value}
                    maxRows={5}
                    style={{ fontSize: '14px' }}
                    className="form-control"
                    onChange={(e) => this.handleInputChange({ target: { name: 'home_address', value: e.target.value } })}
                    placeholder='Enter Home Address'
                  />
                  {controls.home_address.showErrorMsg && <div className="error">*Please enter home address.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="birth_date">Date of Birth{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Label onClick={e => this.bday.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        onChange={(e) => this.handleInputChange({ target: { name: 'birth_date', value: e } })}
                        selected={controls.birth_date.value}
                        showMonthDropdown
                        ref={r => this.bday = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={new Date()}
                        dropdownMode="select"
                        style={{ zIndex: 'auto' }}
                        dateFormat="dd/MM/yyyy"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                  {controls.birth_date.showErrorMsg && <div className="error">*Please select date of birth.</div>}
                </FormGroup>
              </Col>
              <Col xl="4" md="12" xs="12">
                <FormGroup>
                  <Label for="education_qualification">Educational Qualification{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    type="text"
                    name="education_qualification"
                    autocomplete="nofill"
                    id="education_qualification"
                    value={controls.education_qualification.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Enter Educational Qualification" />
                  {controls.education_qualification.showErrorMsg && <div className="error">*Please enter education qualification.</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="languages">Languages Known{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Select
                    options={options}
                    closeMenuOnSelect={false}
                    value={controls.languages.value}
                    onChange={(e) => this.handleInputChange({ target: { name: 'languages', value: e } })}
                    placeholder="Select Language"
                    isMulti />
                  {controls.languages.showErrorMsg && <div className="error">*Please select language.</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup className='d-flex-column'>
                  <Label for="marital_status">Marital Status{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <div>
                    <label className="custom-checkboax-radio--container">
                      <input type="checkbox" name="marital_status" value="married"
                        checked={controls.marital_status.value === 'married' ? true : false}
                        onChange={(e) => this.handleInputChange({ target: { name: 'marital_status', value: 'married' } })}
                      />
                      <span className="checkmark-radio" />
                    </label>
                    <span style={{ marginLeft: '10px' }}>Married</span>
                    &nbsp;&nbsp;&nbsp;
                    <label className="custom-checkboax-radio--container">
                      <input type="checkbox" name="marital_status" value="unmarried" checked={controls.marital_status.value === 'unmarried' ? true : false}
                        onChange={(e) => this.handleInputChange({ target: { name: 'marital_status', value: 'unmarried' } })} />
                      <span className="checkmark-radio" />
                    </label>
                    <span style={{ marginLeft: '10px' }}>Unmarried</span>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row className={controls.marital_status.value === 'unmarried' ? 'hidden' : ''}>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="birth_date">Date of Anniversary<span className="required-field">*</span></Label>
                  <Label onClick={e => this.anni.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        onChange={(e) => this.handleInputChange({ target: { name: 'anniversary_date', value: e } })}
                        selected={controls.anniversary_date.value}
                        showMonthDropdown
                        ref={r => this.anni = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={new Date()}
                        dropdownMode="select"
                        disabled={!controls.marital_status.value || controls.marital_status.value === 'unmarried' ? true : false}
                        style={{ zIndex: 'auto' }}
                        dateFormat="dd/MM/yyyy"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                  {controls.anniversary_date.showErrorMsg && <div className="error">*Please select date of anniversary.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="spouse_name">Spouse Name</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    name="spouse_name"
                    id="spouse_name"
                    disabled={!controls.marital_status.value || controls.marital_status.value === 'unmarried' ? true : false}
                    value={controls.spouse_name.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Type here" />
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="birth_date">Spouse DOB</Label>
                  <Label onClick={e => this.sdob.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        disabled={!controls.marital_status.value || controls.marital_status.value === 'unmarried' ? true : false}
                        onChange={(e) => this.handleInputChange({ target: { name: 'spouse_dob', value: e } })}
                        selected={controls.spouse_dob.value}
                        showMonthDropdown
                        ref={r => this.sdob = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={new Date()}
                        dropdownMode="select"
                        style={{ zIndex: 'auto' }}
                        dateFormat="dd/MM/yyyy"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row className={controls.marital_status.value === 'unmarried' ? 'hidden' : ''}>
              <Col>
                <label className="custom-checkboax1--container">
                  <input type="checkbox" name="completed"
                    checked={controls.isAddChild.value}
                    onChange={(e) => this.handleInputChange({ target: { name: 'isAddChild', value: !controls.isAddChild.value } })}
                  />
                  <span className="checkmark1" />
                </label>&nbsp;&nbsp;Add child
              </Col>
            </Row>
            <br />
            <Row className={controls.marital_status.value === 'unmarried' ? 'hidden' : ''}>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="child_1_name">Child 1 Name</Label>
                  <Input
                    type="text"
                    name="child_1_name"
                    disabled={controls.marital_status.value === 'married' && controls.isAddChild.value ? false : true}
                    id="child_1_name"
                    value={controls.child_1_name.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Type here" />
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="birth_date">Child 1 DOB</Label>
                  <Label onClick={e => this.child1dob.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        onChange={(e) => this.handleInputChange({ target: { name: 'child_1_dob', value: e } })}
                        selected={controls.child_1_dob.value}
                        showMonthDropdown
                        ref={r => this.child1dob = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={new Date()}
                        dropdownMode="select"
                        disabled={controls.marital_status.value === 'married' && controls.isAddChild.value ? false : true}
                        style={{ zIndex: 'auto' }}
                        dateFormat="dd/MM/yyyy"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="child_2_name">Child 2 Name</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    name="child_2_name"
                    id="child_2_name"
                    disabled={controls.marital_status.value === 'married' && controls.isAddChild.value ? false : true}
                    value={controls.child_2_name.value}
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Type here" />
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="birth_date">Child 2 DOB</Label>
                  <Label onClick={e => this.child2dob.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        onChange={(e) => this.handleInputChange({ target: { name: 'child_2_dob', value: e } })}
                        selected={controls.child_2_dob.value}
                        showMonthDropdown
                        ref={r => this.child2dob = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={new Date()}
                        dropdownMode="select"
                        style={{ zIndex: 'auto' }}
                        disabled={controls.marital_status.value === 'married' && controls.isAddChild.value ? false : true}
                        dateFormat="dd/MM/yyyy"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.props.from && this.props.from === 'profile' && <Row>
              <Col xl="12" xs="12" md="12" className="text-align-right" >
                <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" onClick={this.handleOnCancel}>Cancel</Button>
                <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" onClick={this.save}>Save</Button>
              </Col>
            </Row>}
          </CardBody>
        </Card>

      </>
    );
  }
}

export default NewFleetPersonalDetails;